import {
  AssetExtension,
  placeholderFiles,
  StyledPlaceholderContainer,
} from './styled-components/PlaceholderFiles';

interface Props {
  assetExtension?: string;
  title: string;
}

const PlaceholderFile = ({ assetExtension, title }: Props) => {
  const renderPlaceholderFile = (extension: string) => {
    const newExtension =
      !extension.length || !(extension in placeholderFiles)
        ? 'unknown'
        : extension;

    const svgFile = placeholderFiles[newExtension as AssetExtension];

    return (
      <>
        <img src={svgFile.toString()} alt={newExtension} title={title} />
        <h6>.{newExtension}</h6>
      </>
    );
  };

  return (
    <StyledPlaceholderContainer>
      {renderPlaceholderFile(assetExtension.toLowerCase())}
    </StyledPlaceholderContainer>
  );
};

export default PlaceholderFile;
